import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { MutationBitbucketCloudIntegrationCreateArgs } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { CREATE_BITBUCKET_CLOUD_INTEGRATION } from "./gql";

const useCreateBitbucketCloudIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [bitbucketCloudIntegrationCreate, { loading }] = useMutation(
    CREATE_BITBUCKET_CLOUD_INTEGRATION
  );

  const createBitbucketCloudIntegration = useCallback(
    (input: MutationBitbucketCloudIntegrationCreateArgs, successCallback?: () => void) => {
      bitbucketCloudIntegrationCreate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.bitbucketCloudIntegrationCreate) {
            reportSuccess({
              message: `Integration ${data.bitbucketCloudIntegrationCreate.name} was successfully created`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Bitbucket Cloud - Setup Finished", {
              labels: input.customInput?.labels?.length,
              space: input.customInput?.spaceID,
            });
          }
        })
        .catch(onError);
    },
    [bitbucketCloudIntegrationCreate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    createBitbucketCloudIntegration,
    loading,
  };
};

export default useCreateBitbucketCloudIntegration;
